import React, {useEffect} from 'react';
import { graphql } from 'gatsby';
import { useDispatch, useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { handleOmButtonClick } from './forms/OmButton';
import { OmTwoColumnImageRight } from '@om/component-library-react';
import { getIsFormOpenAndPrepopulated} from '@om/redux/selectors/publicWeb/callMeBack';

const TwoColumnImageRightV2 = ({
    twoColumnImageRightContent,
    slot
}) => {
    const dispatch = useDispatch();
    let cmbData;

    if(twoColumnImageRightContent){
        let isPrimaryBtnCmb = twoColumnImageRightContent?.primary_button?.display_text
        === 'CALL ME BACK';

        cmbData = isPrimaryBtnCmb? twoColumnImageRightContent?.primary_button 
            : twoColumnImageRightContent?.secondary_button;
    }

    const {
        isPrepopulatedCmb
    } = useSelector(
        createStructuredSelector({
            isPrepopulatedCmb: getIsFormOpenAndPrepopulated,

        })
    );

    useEffect(() => {
        if(isPrepopulatedCmb && cmbData)
            handleOmButtonClick(cmbData, dispatch, isPrepopulatedCmb, 'TwoColumnImageRightV2');
    }, [
        isPrepopulatedCmb,
        cmbData
    ]);
    
    if (!twoColumnImageRightContent) {
        return '';
    }

    const {
        uid,
        has_boundary,
        image_url,
        image_title,
        image_alt,
        video,
        video_url,
        primary_button,
        secondary_button,
        button_three_url,
        button_three_image_url,
        button_three_open_tab,
        button_four_url,
        button_four_image_url,
        button_four_open_tab,
        use_heading_as_h1,
        text_heading,
        text_content,
        text_sub_title,
        podcast_episode_id,
        podcast_series_id
    } = twoColumnImageRightContent;

    return (
        <OmTwoColumnImageRight
            slot={slot}
            id={uid}
            hasBoundary={has_boundary}
            buttonOneText={primary_button && primary_button.display_text}
            buttonOneActionObject={primary_button && primary_button.action && JSON.stringify(primary_button.action[0])}
            buttonTwoText={secondary_button && secondary_button.display_text}
            buttonTwoActionObject={secondary_button && secondary_button.action && JSON.stringify(secondary_button.action[0])}
            buttonThreeUrl={button_three_url ? button_three_url.href : ''}
            buttonThreeImageUrl={button_three_image_url ? button_three_image_url.url : ''}
            buttonThreeOpenTab={button_three_open_tab}
            buttonFourUrl={button_four_url ? button_four_url.href : ''}
            buttonFourImageUrl={button_four_image_url ? button_four_image_url.url : ''}
            buttonFourOpenTab={button_four_open_tab}
            podcastSeriesId={podcast_series_id}
            podcastEpisodeId={podcast_episode_id}
            onButtonAction={(e) => {
                handleOmButtonClick(e, dispatch, isPrepopulatedCmb);
            }}
        >
            {
                text_heading ?
                    (use_heading_as_h1 ?
                        <h1 slot="text-heading" dangerouslySetInnerHTML={{ __html: text_heading }} /> :
                        <span slot="text-heading" dangerouslySetInnerHTML={{ __html: text_heading }} />) :
                    ''
            }
            {
                text_content ?
                    <span slot="text-content" dangerouslySetInnerHTML={{ __html: text_content }} /> :
                    ''
            }
            {
                text_sub_title ?
                    <span slot="text-sub-title" dangerouslySetInnerHTML={{ __html: text_sub_title }} /> :
                    ''
            }
            {
                image_url ? <img loading="lazy" slot="image" title={image_title} alt={image_alt} src={image_url.url} />
                    : ''
            }
            {
                video && !video_url && !image_url ? <iframe slot='image' src={video.url} frameBorder="0"/>
                    : ''
            }
            {
                video_url && !video && !image_url ? <iframe slot='image' title={video_url.title} src={video_url.href} frameBorder="0" />
                    : ''
            }
        </OmTwoColumnImageRight>
    );
};

export const pageQuery = graphql`
fragment TwoColumnImageRightV2 on Contentstack_2_col_image_right_v2 {
    id
	uid
    has_boundary
    use_heading_as_h1
    podcast_episode_id
    podcast_series_id
    text_heading
    text_sub_title
    text_content
    button_three_open_tab
    button_four_open_tab
    video_url {
    ...Link
    }
    video {
        ...File
    }
    image_url {
    	...File
    }
    image_title
    image_alt
    primary_button {
        ...TwoColumnImageRightPrimaryButton
    }
    secondary_button {
        ...TwoColumnImageRightSecondaryButton
    }
    button_three_url {
    	...Link
    }
    button_three_image_url {
    	...File
    }
    button_four_url {
    	...Link
    }
    button_four_image_url {
    	...File
    }
}
`;

export default TwoColumnImageRightV2;
